import * as React from 'react'
import { Column } from '../types'
import I18n from '../../../../libs/i18n'

interface TextSettingsProps {
  column: Column
  onUpdate: (updates: Partial<Column>) => void
}

export default function TextSettings({
  column,
  onUpdate,
}: TextSettingsProps) {
  const multiline = column.settings?.multiline === true ||
    column.settings?.multiline === 'true'

  return (
    <div className="form-check">
      <input
        type="checkbox"
        className="form-check-input"
        id={`multiline-${column.id}`}
        checked={multiline}
        onChange={(e) =>
          onUpdate({
            settings: { ...column.settings, multiline: e.target.checked },
          })
        }
      />
      <label className="form-check-label small" htmlFor={`multiline-${column.id}`}>
        {I18n.t('project_groups.columns_editor.multiline')}
      </label>
    </div>
  )
}
